/* Private visual mock-up: overlapping glyph masks, never a production cut file. */
(() => {
  const canvas = (width, height) => { const c=document.createElement('canvas');c.width=Math.max(1,Math.ceil(width));c.height=Math.max(1,Math.ceil(height));return c; };
  const context = c => c.getContext('2d', {willReadFrequently:true});
  function bounds(c) {
    const data=context(c).getImageData(0,0,c.width,c.height).data;
    let left=c.width,top=c.height,right=-1,bottom=-1;
    for(let y=0;y<c.height;y++)for(let x=0;x<c.width;x++)if(data[(y*c.width+x)*4+3]>48){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}
    return right<left?null:{left,top,right,bottom,width:right-left+1,height:bottom-top+1};
  }
  function trim(c, baseline) {
    const b=bounds(c);if(!b)return null;
    const out=canvas(b.width,b.height);context(out).drawImage(c,-b.left,-b.top);
    return {canvas:out,baseline:baseline-b.top};
  }
  function edges(c) {
    const w=c.width,h=c.height,data=context(c).getImageData(0,0,w,h).data;
    const left=Array(h).fill(Infinity),right=Array(h).fill(-Infinity),top=Array(w).fill(Infinity),bottom=Array(w).fill(-Infinity);
    for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(data[(y*w+x)*4+3]>48){left[y]=Math.min(left[y],x);right[y]=Math.max(right[y],x);top[x]=Math.min(top[x],y);bottom[x]=Math.max(bottom[x],y);}
    return {left,right,top,bottom};
  }
  function components(c) {
    const w=c.width,h=c.height,n=w*h,data=context(c).getImageData(0,0,w,h).data,seen=new Uint8Array(n),queue=new Int32Array(n),parts=[];
    for(let p=0;p<n;p++){
      if(seen[p]||data[p*4+3]<=48)continue;
      let head=0,tail=1;queue[0]=p;seen[p]=1;const pixels=[];
      while(head<tail){const q=queue[head++];pixels.push(q);const x=q%w;for(const r of [x?q-1:-1,x<w-1?q+1:-1,q>=w?q-w:-1,q<n-w?q+w:-1])if(r>=0&&!seen[r]&&data[r*4+3]>48){seen[r]=1;queue[tail++]=r;}}
      parts.push(pixels);
    }
    return parts.sort((a,b)=>b.length-a.length);
  }

  function settleMarks(c) {
    const parts=components(c);if(parts.length<2)return c;
    const out=canvas(c.width,c.height),outCtx=context(out),base=outCtx.createImageData(c.width,c.height);
    for(const p of parts[0])base.data.set([255,255,255,255],p*4);outCtx.putImageData(base,0,0);
    for(const pixels of parts.slice(1)){
      const mark=canvas(c.width,c.height),markCtx=context(mark),data=markCtx.createImageData(c.width,c.height);
      for(const p of pixels)data.data.set([255,255,255,255],p*4);markCtx.putImageData(data,0,0);
      const a=bounds(out),b=bounds(mark),ae=edges(out),be=edges(mark);let dy;
      if((b.top+b.bottom)<(a.top+a.bottom)){
        dy=Infinity;for(let x=0;x<c.width;x++)if(isFinite(ae.top[x])&&isFinite(be.bottom[x]))dy=Math.min(dy,ae.top[x]-be.bottom[x]);
        if(isFinite(dy))dy+=1;
      }else{
        dy=-Infinity;for(let x=0;x<c.width;x++)if(isFinite(ae.bottom[x])&&isFinite(be.top[x]))dy=Math.max(dy,ae.bottom[x]-be.top[x]);
        if(isFinite(dy))dy-=1;
      }

      outCtx.drawImage(mark,0,isFinite(dy)?dy:0);
    }
    return out;
  }
  function glyph(character, family, stroke) {
    const measure=context(canvas(1,1));measure.font=`100px ${family}`;
    const m=measure.measureText(character),pad=Math.ceil(stroke/2)+3;
    const c=canvas(m.actualBoundingBoxLeft+m.actualBoundingBoxRight+pad*2,m.actualBoundingBoxAscent+m.actualBoundingBoxDescent+pad*2),ctx=context(c);
    const baseline=pad+m.actualBoundingBoxAscent;ctx.font=`100px ${family}`;ctx.fillStyle='#fff';ctx.strokeStyle='#fff';ctx.lineJoin='round';ctx.lineWidth=stroke;
    if(stroke)ctx.strokeText(character,pad+m.actualBoundingBoxLeft,baseline);
    ctx.fillText(character,pad+m.actualBoundingBoxLeft,baseline);
    return trim(settleMarks(c),baseline);
  }
  function makeLine(text, family, stroke) {
    const glyphs=[...text].filter(c=>c!==' ').map(c=>glyph(c,family,stroke)).filter(Boolean);
    let merged=glyphs[0];if(!merged)return null;
    for(const next of glyphs.slice(1)){
      const a=edges(merged.canvas),b=edges(next.canvas),top=Math.min(-merged.baseline,-next.baseline),bottom=Math.max(merged.canvas.height-merged.baseline,next.canvas.height-next.baseline);
      let contact=-Infinity;
      for(let y=Math.ceil(top);y<bottom;y++){
        const ay=Math.round(y+merged.baseline),by=Math.round(y+next.baseline);
        if(ay>=0&&ay<a.right.length&&by>=0&&by<b.left.length&&isFinite(a.right[ay])&&isFinite(b.left[by]))contact=Math.max(contact,a.right[ay]-b.left[by]);
      }
      const x=isFinite(contact)?Math.max(0,contact-1):merged.canvas.width;
      const out=canvas(Math.max(merged.canvas.width,x+next.canvas.width),bottom-top),ctx=context(out);
      ctx.drawImage(merged.canvas,0,-merged.baseline-top);ctx.drawImage(next.canvas,x,-next.baseline-top);
      merged=trim(out,-top);
    }
    return merged;
  }
  function stackLines(lines) {
    let merged={canvas:lines[0].canvas,baselines:[lines[0].baseline]};
    for(const b of lines.slice(1)){
      const a=merged,width=Math.max(a.canvas.width,b.canvas.width),ax=Math.floor((width-a.canvas.width)/2),bx=Math.floor((width-b.canvas.width)/2),ae=edges(a.canvas),be=edges(b.canvas);
      let contact=-Infinity;
      for(let x=0;x<width;x++)if(x>=ax&&x<ax+a.canvas.width&&x>=bx&&x<bx+b.canvas.width&&isFinite(ae.bottom[x-ax])&&isFinite(be.top[x-bx]))contact=Math.max(contact,ae.bottom[x-ax]-be.top[x-bx]);
      const by=isFinite(contact)?Math.max(a.baselines.at(-1)+6-b.baseline,contact-1):a.canvas.height;
      const out=canvas(width,Math.max(a.canvas.height,by+b.canvas.height)),ctx=context(out);ctx.drawImage(a.canvas,ax,0);ctx.drawImage(b.canvas,bx,by);
      merged={canvas:out,baselines:[...a.baselines,by+b.baseline]};
    }
    return merged;
  }
  const layoutCache=new Map();
  function lettering({lines,family,widthUnits,strokeUnits=0}) {
    const key=JSON.stringify([lines,family]);
    let layout=layoutCache.get(key);
    if(!layout){
      layout=stackLines(lines.map(line=>makeLine(line,family,0)));
      if(layoutCache.size>=24)layoutCache.delete(layoutCache.keys().next().value);
      layoutCache.set(key,layout);
    }

    let result=layout;
    if(strokeUnits){


      const ratio=4,innerScale=(widthUnits-strokeUnits)*ratio/layout.canvas.width;
      const radius=strokeUnits*ratio/2;
      const out=canvas(widthUnits*ratio,layout.canvas.height*innerScale+radius*2),ctx=context(out);
      for(let i=0;i<32;i++){
        const angle=i*Math.PI/16;
        ctx.drawImage(layout.canvas,radius+Math.cos(angle)*radius,radius+Math.sin(angle)*radius,layout.canvas.width*innerScale,layout.canvas.height*innerScale);
      }
      ctx.drawImage(layout.canvas,radius,radius,layout.canvas.width*innerScale,layout.canvas.height*innerScale);
      result={canvas:out,baselines:layout.baselines.map(y=>radius+y*innerScale)};
    }
    const scale=widthUnits/result.canvas.width;
    return {...result,widthUnits,heightUnits:result.canvas.height*scale,scale,addedStrokeUnits:strokeUnits,parts:components(result.canvas).length};
  }
  window.RISTopperRenderer={lettering,components};
})();
